import { decodeOAuthState } from './decodeOAuthState';
import { encodeOAuthState } from './encodeOAuthState';
import { getAuthenticatedCookieKey } from './getAuthenticatedCookieKey';

export const oauthHelpers = {
    decodeOAuthState,
    encodeOAuthState,
    getAuthenticatedCookieKey,
};
